import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.config.method?.toUpperCase(), response.config.url, 'Status:', response.status);
    console.log('Response data:', response.data);
    return response;
  },
  (error) => {
    console.error('Response Error:', error.response?.status, error.response?.data || error.message);
    
    // Extract error message from API response
    let errorMessage = 'An error occurred';
    
    if (error.response?.data) {
      // Try different common error message formats from APIs
      if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error;
      } else if (error.response.data.errors) {
        // Handle validation errors array
        if (Array.isArray(error.response.data.errors)) {
          errorMessage = error.response.data.errors.map((e: any) => e.message || e).join(', ');
        } else {
          errorMessage = JSON.stringify(error.response.data.errors);
        }
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    if (error.response?.status === 401) {
      const url = String(error.config?.url ?? '');
      const isPublicAuthRequest =
        url.includes('/auth/login') || url.includes('/auth/register');

      // Failed login/register is 401 too — do not hard-navigate or the page reloads
      if (isPublicAuthRequest) {
        return Promise.reject(error);
      }

      toast.error('Session expired. Please login again.');
      localStorage.removeItem('token');
      window.location.href = '/login';
    } else {
      // Show error toast for other errors
      toast.error(errorMessage);
    }
    
    return Promise.reject(error);
  }
);

export default api;
